/* eslint-disable import/no-webpack-loader-syntax */
// Exposes the exports for file.js to the global context on property "libraryName".
// In web browsers, window.libraryName is then available.
// this is similar to the file in reactifi, but has a few changes as noted below
require('expose-loader?exposes=React!react');
require('expose-loader?exposes=ReactDOM!react-dom');
require('expose-loader?exposes=PropTypes!prop-types');

// these are exposed in foundry apps for when we pull in foundry externals, but those are not used in dashifi
// require('expose-loader?exposes=moment!moment');
// require('expose-loader?exposes=ReactBootstrapTable!react-bootstrap-table-next');
// require('expose-loader?exposes=ReactRedux!react-redux');
// require('expose-loader?exposes=ReactRouterRedux!react-router-redux');
// require('expose-loader?exposes=Redux!redux');
// require('expose-loader?exposes=ReduxJsonApi!redux-json-api');
// require('expose-loader?exposes=i18nextFoundry!i18next');
// require('expose-loader?exposes=pluralize!pluralize');

// this is disabled with dashifi; we may not need it or if we are going to use it, we need to set up a new backend service
// require('expose-loader?ahoy!@everfi/foundry-analytics-js');

// these cause engage to break and don't save space until the sdk-web is in use
// require('expose-loader?DesignSystem!@everfi/design-system');
// require('expose-loader?ChakraUI!@chakra-ui/react');
// can't get this one to work, but would be another nice one to include
// require("expose-loader?DomHelpers!dom-helpers");
